import { request } from "../../utils/config"

export const GET_FILTERED_RETURN_SALES = async (params) => {
  const response = await request({
    url: `ReturnSales/GetReturnSalesByFilter`,
    params: params,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
    },
  })
  return response.data
}

export const GET_ALL_FILTERED_RETURN_SALES = async (params) => {
  const response = await request({
    url: `ReturnSales/GetReturnSalesByFilter`,
    params: { ...params, PageSize: 10000000 },
    headers: {
      Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
    },
  })
  return response.data
}

export const GET_ALL_FILTERED_RETURN_SALES_IS_DEFECTIVE = async (params) => {
  const response = await request({
    url: `ReturnSales/GetReturnSalesByFilter`,
    params: { ...params, PageSize: 10000000 },
    headers: {
      Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
    },
  })
    console.log(response.data)
  return response.data
}

export const GET_RETURN_SALES = async (params) => {
  const response = await request({
    url: `ReturnSales`,
    params: params,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
    },
  })
  return response.data
}
export const GET_RETURN_SALES_IS_DEFECTIVE = async (params) => {
  const response = await request({
    url: `ReturnSales`,
    params: params,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
    },
  })
  const isDefectives = response?.data?.data.filter((e) => e.isDefective)
  response.data.data = isDefectives
  return response.data
}

export const GET_ALL_RETURN_SALES = async (params) => {
  const response = await request({
    url: `ReturnSales`,
    params: { ...params, PageSize: 10000000 },
    headers: {
      Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
    },
  })
  return response.data
}

export const GET_RETURN_SALE = async (id) => {
  const response = await request({
    url: `ReturnSales/${id}`,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
    },
  })
  return response.data
}
